import type { AsyncData } from '#app';
import type { IModelResponse } from '~/services/base/dto/base.dto';
import type {
  IModelRegisterRequest,
  IModelRegisterResponse,
} from './dto/admin-console.dto';

export class AdminConsoleRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async register(
    body: IModelRegisterRequest
  ): Promise<AsyncData<IModelResponse<IModelRegisterResponse>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/admin-console`,
      this.configService,
      {
        method: 'POST',
        body: {
          data: body,
        },
      }
    );

    return dataResult;
  }
}
